import React from 'react';
import styled from 'styled-components';

import { Spinner } from 'widgets/Spinner';

import { IconSearch } from '../../icon';

interface SearchProps {
    placeholder: string;
    value?: string;
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    autoFocus?: boolean;
    round?: boolean;
    disabled?: boolean;
    loading?: boolean;
}
export const SearchInput = React.forwardRef<HTMLInputElement, SearchProps>(
    ({ placeholder, value, onChange, onFocus, onBlur, autoFocus, round, disabled, loading }, ref) => (
        <SearchWrapper $round={round}>
            <SearchBox
                ref={ref}
                $round={round}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onFocus={onFocus}
                onBlur={onBlur}
                autoFocus={autoFocus}
                disabled={disabled || loading}
            />
            <IconWrapper>{loading ? <Spinner size={16} /> : <IconSearch size="micro" />}</IconWrapper>
        </SearchWrapper>
    ),
);

SearchInput.displayName = 'SearchInput';

const SearchWrapper = styled.div<{ $round?: boolean }>`
    position: relative;
    height: ${({ $round }) => ($round ? 36 : 35)}px;
    border: 1px solid ${({ theme, $round }) => ($round ? theme.colors.cocoa100 : theme.border.light)};
    border-radius: ${({ $round }) => ($round ? 9999 : 4)}px;
    background: ${({ $round }) => ($round ? 'white' : 'transparent')};
    overflow: hidden;
`;

const SearchBox = styled.input<{ $round?: boolean }>`
    width: 100%;
    height: 100%;
    border: none;
    padding: ${({ $round }) => ($round ? '0 36px 0 16px' : '0 8px 0 24px')};
    border-radius: ${({ $round }) => ($round ? 9999 : 4)}px;
    background: ${({ $round }) => ($round ? 'white' : 'transparent')};
    color: ${({ theme, $round }) => ($round ? theme.colors.cocoa900 : 'inherit')};

    &::placeholder {
        color: ${({ theme, $round }) => ($round ? theme.colors.cocoa500 : 'inherit')};
    }

    &:disabled {
        background: ${({ theme }) => theme.intent.disabled};
        cursor: not-allowed;
    }
`;

const IconWrapper = styled.div`
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translate(0, -50%);
    color: ${({ theme }) => theme.text.subtle};
`;
